// extracted by mini-css-extract-plugin
module.exports = {"container":"EditStaff_container__1DcB-","line":"EditStaff_line__3zuKr"};